export default __webpack_public_path__ + "static/media/bookingFooter.e32b4555.svg";